import { CAMPAIGN_ID_PARAM } from "@/constants";
import { getRoutePath } from "@/lib/utils";
import type { PushParams } from "@/types/global/route";

export const resolveHrefWithCampaign = (
  target: PushParams | string,
  campaignId?: string,
): string => {
  const href = typeof target === "string" ? target : getRoutePath(target);
  if (!campaignId) return href;

  const [path, search] = href.split("?");
  const params = new URLSearchParams(search);
  if (params.has(CAMPAIGN_ID_PARAM)) return href;

  params.set(CAMPAIGN_ID_PARAM, campaignId);
  return `${path}?${params.toString()}`;
};
